<template>
  <div class="max-w-5xl mx-auto px-4 pt-4 pb-1 sm:pb-4 space-y-4">
    <!-- Here you use QueryAutocomplete -->
    <QueryAutocomplete v-model="search" :stance="filters.stance" :topic="filters.topic" :dataset="filters.dataset"
      placeholder="Choose a claim" @select="onSelect" @confirm="emit('search-requested')" :transform="mapResponse" />
  </div>
</template>

<script setup lang="ts">
import { ref, reactive, watch } from 'vue'

const props = defineProps<{ sticky?: boolean; initialLabel?: string }>()
import type { ClaimSearchHit, SearchResponse } from '../types/search'
import QueryAutocomplete from './ClaimAutocomplete.vue'

const search = ref(props.initialLabel ?? '')

// define filters used by the template bindings
const filters = reactive<{
  stance: string | null
  topic: string | null
  dataset: string | null
}>({
  stance: null,
  topic: null,
  dataset: null,
})

const mapResponse = (resp: SearchResponse): ClaimSearchHit[] => resp.hits

// 🔈 define the event
const emit = defineEmits<{
  (e: 'select-claim', payload: { id: string; label: string; item: ClaimSearchHit }): void
  (e: 'claim-input-changed', value: string): void
  (e: 'search-requested'): void
}>()

const onSelect = (payload: { value: string; label: string; item: ClaimSearchHit }) => {
  emit('select-claim', {
    id: String(payload.item.claim_id),
    label: payload.label,
    item: payload.item,
  })
}

watch(search, (value) => {
  emit('claim-input-changed', value)
})
</script>
